import { useMutation } from "@tanstack/react-query";

import { sendTestNotification } from "../../api/notification.api";
import { useToastContext } from "../../containers/ToastContextWrapper";

export const useSendTestNotification = () => {
  const { showToast } = useToastContext();

  return useMutation({
    mutationFn: sendTestNotification,
    onSuccess: () => {
      showToast({
        title: "Notification sent",
        description: "Check your phone for the test push.",
        type: "success",
      });
    },
    onError: (error: Error) => {
      console.error("Failed to send test notification", error);
      showToast({
        title: "Couldn't send notification",
        description: "Please try again in a moment.",
        type: "error",
      });
    },
  });
};
